import React from 'react'
import styled from "styled-components";
import HorizontalAlign from "./horizontalAlign"
import LabelInput from "./labelInput"
import Input from "./input"
import SelectInput from "./selectInput"
import ButtonForm from "./buttonForm"
import {RadioButton, RadioGroup} from "react-radio-buttons";
import Link from "./link";

const StyledDiv = styled.div`
  width: 45%;
`

const FormUser = (
    {
        handleSubmit = null,
        handleChange = null,
        data = {},
        clubs = {},
        licences = {},
        handleChangeClub = null,
        licenceSolo = false,
        setData = null,
        resetForm = null
    }) => {
    return (
        <form onSubmit={handleSubmit}>
            <HorizontalAlign content={
                <>
                    <StyledDiv>
                        <LabelInput content="Adresse mail" redStar={true}/>
                        <Input name="mail" onChange={handleChange} defaultValue={data.mail}/>
                        <LabelInput content="Mot de passe" redStar={true}/>
                        <Input type="password" name="password" onChange={handleChange} defaultValue={null}/>
                        <LabelInput content="Prénom" redStar={true}/>
                        <Input name="prenom" onChange={handleChange} defaultValue={data.prenom}/>
                        <LabelInput content="Nom" redStar={true}/>
                        <Input name="nom" onChange={handleChange} defaultValue={data.nom}/>
                    </StyledDiv>
                    <StyledDiv>
                        <LabelInput content="De quel club s'occupe-t-il ?" redStar={true}/>
                        <SelectInput
                            content={
                                <>
                                    <option value="0">Sélectionnez un club</option>
                                    <option value="none">Aucun</option>
                                    {
                                        clubs.length > 0 ?
                                            clubs.map(club => {
                                                return (
                                                    <option key={club._id} value={club._id}>
                                                        {club.nom}
                                                    </option>
                                                )
                                            })
                                            : null
                                    }
                                </>
                            }
                            name="idClub"
                            onChange={handleChangeClub}
                            defaultValue={data.idClub}
                        />
                        {
                            licenceSolo === true ?
                                <>
                                    <LabelInput content="Quelle licence est associée ?" redStar={true}/>
                                    <SelectInput
                                        content={
                                            <>
                                                <option value="none">Sélectionnez une licence</option>
                                                {
                                                    licences.length > 0 ?
                                                        licences.map(licence => {
                                                            return (
                                                                <option key={licence._id} value={licence._id}>
                                                                    {licence.nom} {licence.prenom}
                                                                </option>
                                                            )
                                                        })
                                                        : null
                                                }
                                            </>
                                        }
                                        name="licenceSolo"
                                        onChange={handleChange}
                                    />
                                </>
                                : null
                        }

                        <LabelInput content="Est-il administrateur ?" redStar={true}/>
                        <RadioGroup onChange={event => setData({...data, admin: event})} name="admin" horizontal>
                            <RadioButton value="true" rootColor="#4466ca" pointColor={"#171d45"}>Oui</RadioButton>
                            <RadioButton value="false" rootColor="#4466ca" pointColor={"#171d45"}>Non</RadioButton>
                        </RadioGroup>
                    </StyledDiv>
                </>
            }/>
            <Link content="Réinitialiser le formulaire" onClick={resetForm} cursor="pointer"/>
            <br/>
            <ButtonForm name="envoyer" width="100%"/>
        </form>
    )
}

export default FormUser
